const lowCodeStore = {
	namespaced: true,
	state: {
		test: 1,
		selectdItem:null,
		centerList:[],
		navList:[],
		navPhoneList:[],
		footerList:[],
		footerPhoneList:[],
		homeList:[],
		num:1,
		bottomCartPhoneList:[],
		mapGoodsListObj:{},
		products:[],
		detailList:[],
		classifyList:[],
		globalDialogList:[],
		goodsConfig:[],
		classifyListPreview:[],
		cartNum:0,
		systemLanguage:"",
		selectLanguage:""
	},
	getters: {

	},
	mutations: {
		setMapGoodsListObj(state,e) {
			state.mapGoodsListObj[e.id] = e.list
			console.log('state.mapGoodsListObj',state.mapGoodsListObj)
		},
		setList(state,e) {
			state[e.filed] = e.list
		},
		setNum(state,e) {
			state.num = e.num
		},
		setSelectdItem(state,e) {
			console.log('setSelectdItem')
			state.selectdItem = e
		},
		setCenterList:(state,payload)=>{
			console.log('setCenterList state',state)
			console.log('setCenterList payload',payload)
			state.centerList = payload.centerList
		}
	},
	actions: {

	}
}
export default lowCodeStore